import {
    EDITMERCHANTWIRE_SUCCESS,
    EDITMERCHANTWIRE_FAILED,
    RESET_EDITMERCHANTWIRE,
    LOADING_EDITMERCHANTWIRE,
    NETWORK_ERROR_EDITMERCHANTWIRE
} from "../types/index";
import { partnerServices } from "../../config/axios";

const reseteditMerchantWire = () => {
    return { type: RESET_EDITMERCHANTWIRE };
};

const editMerchantWire = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_EDITMERCHANTWIRE });
    await partnerServices
        .post("updateMerchantWire", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(editMerchantWiresuccess(res.data));
                    break;
                default:
                    dispatch(editMerchantWireFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_EDITMERCHANTWIRE,
                payload: err
            });
        });
};
function editMerchantWiresuccess(data) {
    return {
        type: EDITMERCHANTWIRE_SUCCESS,
        payload: data
    };
}
function editMerchantWireFailed(data) {
    return {
        type: EDITMERCHANTWIRE_FAILED,
        payload: data
    };
}

export { reseteditMerchantWire, editMerchantWire };
